import './TonAuthSheet.sass';

import React, { FC, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { TonAuthSheetProps } from './TonAuthSheet.interface';
import { useDesktop, useTranslator } from '$hooks';
import { Api } from '$api';
import { mainActions } from '$store/main';
import { QrCode } from '$uikit';
import { IcAngleRight16, IcTonkeeper56 } from '$assets';
import { DiamondsSubscriptionSheet, Loader } from '$shared/components';
import { goTo } from '$navigation/helper';
import { NFT } from '$shared/constants/pages';
import { ENDPOINT } from '$shared/constants';

export const TonAuthSheet: FC<TonAuthSheetProps> = (props) => {
  const dispatch = useDispatch();
  const [sessionId, setSessionId] = useState('');
  const t = useTranslator();
  const isDesktop = useDesktop();

  const getAuthStatus = useCallback(() => {
    Api.get(`/nft/my`)
      .then((data: any) => {
        dispatch(mainActions.setTonAddress(data.tonAddress));
        dispatch(mainActions.setPopup(null));
        goTo(NFT);

        if (data.canSubscribe) {
          dispatch(mainActions.setPopup(<DiamondsSubscriptionSheet />));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, [dispatch]);

  useEffect(() => {
    Api.get(`/ton_auth/create_session`)
      .then((data: any) => {
        setSessionId(data.id);
      })
      .catch((e) => {
        console.error(e);
      });

    const interval = setInterval(getAuthStatus, 3000);
    return () => clearInterval(interval);
  }, [getAuthStatus]);

  const tonLoginRequestUrl = `${ENDPOINT}/ton_auth/${sessionId}/request`;
  const tonAuthLink = `https://app.tonkeeper.com/ton-login/${tonLoginRequestUrl}`;

  return (
    <BottomSheet title={t('ton_auth_sheet_title')}>
      <div className="TonAuthSheet__cont">
        <div className="TonAuthSheet__caption">{t('ton_auth_sheet_caption')}</div>
        {sessionId ? (
          <div>
            <QrCode data={tonAuthLink} />
            <a
              href={tonAuthLink}
              target="_blank"
              className="TonAuthSheet__method"
              rel="noreferrer"
            >
              <div className="TonAuthSheet__method__icon">
                <IcTonkeeper56 />
              </div>
              <div className="TonAuthSheet__method__cont">
                <div className="TonAuthSheet__method__title">Tonkeeper</div>
                <div className="TonAuthSheet__method__caption">
                  {t('ton_auth_sheet_connect')}
                </div>
              </div>
              <div className="TonAuthSheet__method__chevron">
                <IcAngleRight16 />
              </div>
            </a>
          </div>
        ) : (
          <Loader isWrapped />
        )}
      </div>
    </BottomSheet>
  );
};
